import { Injectable } from '@angular/core';
import { Observable, of, catchError, delay, retry, tap, map } from 'rxjs';
import { UserInfoFormData } from '../_actions/user-info.actions';
import { environment } from 'src/environments/environment';
import { RatesResponse } from '../_models/rates';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoggingService } from './logging.service';
import brandInfo from "../../environments/brand.json";

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  constructor(private httpClient: HttpClient, private loggingService: LoggingService) { }

  submitUserInfo(formData: UserInfoFormData): Observable<any> {
    // Simulating API call with a delay
    return this.httpClient.post<RatesResponse>(`${environment.apiUrl}/v1/api/rev-landing-signup`, {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email
    })
      .pipe(
        retry(1),
        catchError(this.loggingService.handleError)
      )
  }
} 
